import script from "./AutoAIRoles.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIRoles.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIRoles.vue?vue&type=style&index=0&id=3b060def&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b060def"]])

export default __exports__